export default __webpack_public_path__ + "static/media/whatsappSlide4.b36aa44a.svg";